import { constants } from '..';

const setMonitoringLoadingAction = flag => ({
  type: constants.monitoring.SET_MONITORING_LOADING,
  flag,
});

const getMonitoringAction = payload => ({
  type: constants.monitoring.GET_MONITORING,
  payload,
});

const setMonitoringAction = monitoring => ({
  type: constants.monitoring.SET_MONITORING,
  monitoring,
});

const clearMonitoringAction = () => ({
  type: constants.monitoring.CLEAR_MONITORING,
});

const getAvailabilityDevices = () => ({
  type: constants.monitoring.GET_AVAILABILITY_DEVICES,
});

const setAvailabilityDevices = availabilityDevices => ({
  type: constants.monitoring.SET_AVAILABILITY_DEVICES,
  availabilityDevices,
});

const clearAvailabilityDevices = () => ({
  type: constants.monitoring.CLEAR_AVAILABILITY_DEVICES,
});

const getAvailabilityDevicesByPeriod = payload => ({
  type: constants.monitoring.GET_AVAILABILITY_DEVICES_BY_PERIOD,
  payload,
});

const setAvailabilityDevicesByPeriod = availabilityDevicesByPeriod => ({
  type: constants.monitoring.SET_AVAILABILITY_DEVICES_BY_PERIOD,
  availabilityDevicesByPeriod,
});

const clearAvailabilityDevicesByPeriod = () => ({
  type: constants.monitoring.CLEAR_AVAILABILITY_DEVICES_BY_PERIOD,
});

const setApplicationsLoadingAction = flag => ({
  type: constants.monitoring.SET_APPLICATIONS_LOADING,
  flag,
});

const getApplicationsAction = body => ({
  type: constants.monitoring.GET_APPLICATIONS,
  body,
});

const setApplicationsAction = applications => ({
  type: constants.monitoring.SET_APPLICATIONS,
  applications,
});

const clearApplicationsAction = () => ({
  type: constants.monitoring.CLEAR_APPLICATIONS,
});

const setDevicesLoadingAction = flag => ({
  type: constants.monitoring.SET_DEVICES_LOADING,
  flag,
});

const getDevicesAction = body => ({
  type: constants.monitoring.GET_DEVICES,
  body,
});

const setDevicesAction = (devices, header, count) => ({
  type: constants.monitoring.SET_DEVICES,
  devices,
  header,
  count,
});

const clearDevicesAction = () => ({
  type: constants.monitoring.CLEAR_DEVICES,
});

const setLogsLoadingAction = flag => ({
  type: constants.monitoring.SET_LOGS_LOADING,
  flag,
});

const getLogsAction = body => ({
  type: constants.monitoring.GET_LOGS,
  body,
});

const setLogsAction = (logs, header, count) => ({
  type: constants.monitoring.SET_LOGS,
  logs,
  header,
  count,
});

const clearLogsAction = () => ({
  type: constants.monitoring.CLEAR_LOGS,
});

const setScheduledActionLogsLoadingAction = flag => ({
  type: constants.monitoring.SET_SCHEDULED_ACTION_LOGS_LOADING,
  flag,
});

const getScheduledActionLogsAction = body => ({
  type: constants.monitoring.GET_SCHEDULED_ACTION_LOGS,
  body,
});

const setScheduledActionLogsAction = (scheduledActionLogs, header, count) => ({
  type: constants.monitoring.SET_SCHEDULED_ACTION_LOGS,
  scheduledActionLogs,
  header,
  count,
});

const clearScheduledActionLogsAction = () => ({
  type: constants.monitoring.CLEAR_SCHEDULED_ACTION_LOGS,
});

const exportLogsAsyncAction = (filterBody, filename) => ({
  type: constants.monitoring.EXPORT_LOGS_ASYNC,
  filter: filterBody,
  filename,
});

const setLogsExportIdentifierAction = identifier => ({
  type: constants.monitoring.SET_LOGS_EXPORT_IDENTIFIER,
  identifier,
});

const getDeviceAnalyticsAction = id => ({
  type: constants.monitoring.GET_DEVICE_ANALYTICS,
  id,
});

const setDeviceAnalyticsAction = analytics => ({
  type: constants.monitoring.SET_DEVICE_ANALYTICS,
  analytics,
});

const clearDeviceAnalyticsAction = () => ({
  type: constants.monitoring.CLEAR_DEVICE_ANALYTICS,
});

export const monitoringActions = {
  setMonitoringLoadingAction,
  getMonitoringAction,
  setMonitoringAction,
  clearMonitoringAction,
  setApplicationsLoadingAction,
  getApplicationsAction,
  setApplicationsAction,
  clearApplicationsAction,
  setDevicesLoadingAction,
  getDevicesAction,
  setDevicesAction,
  clearDevicesAction,
  setLogsLoadingAction,
  getLogsAction,
  setLogsAction,
  clearLogsAction,
  setScheduledActionLogsLoadingAction,
  getScheduledActionLogsAction,
  setScheduledActionLogsAction,
  clearScheduledActionLogsAction,
  exportLogsAsyncAction,
  setLogsExportIdentifierAction,
  getAvailabilityDevices,
  setAvailabilityDevices,
  clearAvailabilityDevices,
  getAvailabilityDevicesByPeriod,
  setAvailabilityDevicesByPeriod,
  clearAvailabilityDevicesByPeriod,
  getDeviceAnalyticsAction,
  setDeviceAnalyticsAction,
  clearDeviceAnalyticsAction,
};
